import { useQuery } from '@tanstack/react-query';

import { useApi } from '../contexts/ApiContext';
import { useIsBot, useIsCheckingAuth } from '../contexts/AuthContext';

/**
 * The form campaign to insert in a document for the current user or visitor. Client only: the
 * campaign depends on the forms the person already filled.
 */
export default function useFormCampaign(documentId: string | null, opts = null) {
    const api = useApi();
    const { enabled = true, ...queryOpts } = opts || {};
    const isCheckingAuth = useIsCheckingAuth();
    const isBot = useIsBot();
    const { data = null, ...queryResult } = useQuery<FormCampaign | null>({
        queryKey: ['form_campaign', documentId],
        queryFn: ({ queryKey: [, idParam], signal }) =>
            api.documents.formCampaign(idParam as string, { signal }),
        enabled:
            enabled &&
            typeof window !== 'undefined' &&
            documentId !== null &&
            !isCheckingAuth &&
            !isBot,
        // Keep the campaign while the page is open, even when the user logs in: refetched after
        // an answer, the API would replace the results of the form by another campaign
        staleTime: Infinity,
        ...queryOpts,
    });

    return {
        campaign: data,
        ...queryResult,
    };
}
